// Wrap Images on Imagegallery template with anchor
$(document).ready(function(){
//   	var $imageSrc = $('div#image-gallery > img').attr('src');
//   	$('div#image-gallery img').wrap('<a data-fancybox="gallery" href="' + $imageSrc + '"></a>');
});
